import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	team: {
		id: 'eoc.auto-complete.custom-option.team-icon.no-translate',
		defaultMessage: 'Group',
		description: 'Label of group icon that indicates responder is a group',
	},
	schedule: {
		id: 'eoc.auto-complete.custom-option.schedule-icon.no-translate',
		defaultMessage: 'Calendar',
		description: 'Label of calendar icon that indicates responder is a schedule',
	},
	escalation: {
		id: 'eoc.auto-complete.custom-option.escalation-icon.no-translate',
		defaultMessage: 'Chart',
		description: 'Label of chart icon that indicates responder is a escalation',
	},
	user: {
		id: 'eoc.auto-complete.custom-option.user-icon.no-translate',
		defaultMessage: 'User',
		description: 'Label of user icon that indicates responder is a user',
	},
});
